import classNames from 'classnames';
import PropTypes from 'prop-types';

const Container = ({ className, mode, children, style }) => {
  const modeClass = classNames({
    'container lg:max-w-screen-md xl:max-w-screen-lg': mode === Container.MODE.NARROW,
    'container lg:max-w-screen-lg xl:max-w-screen-xl': mode === Container.MODE.MEDIUM,
    'w-full mx-auto px-4 sm:px-6 lg:px-8 xl:px-[120px] lg:max-w-screen-4xl xl:max-w-screen-5xl':
      mode === Container.MODE.WIDE,
    '': mode === Container.MODE.NO_CONTAINER,
  });

  return (
    <div className={`${modeClass} ${className}`} style={style}>
      {children}
    </div>
  );
};

Container.MODE = {
  NARROW: 'narrow',
  MEDIUM: 'medium',
  WIDE: 'wide',
  NO_CONTAINER: 'no_container',
};

Container.propTypes = {
  className: PropTypes.string,
  mode: PropTypes.oneOf(Object.values(Container.MODE)),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Container.defaultProps = {
  className: '',
  mode: Container.MODE.MEDIUM,
  children: '',
};

export default Container;
